export enum ResignationRequestStatus {
Temporary,
Pending,
Validating,
Approved,
Rejected,
}
